module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"no":{"title":"\u0027Edutain\u0027 deg selv med videoreiser"},"en":{"title":"Edutain yourself with video journeys"}}')
  delete Component.options._Ctor
}
